import { useQuery } from 'hooks/useCustomQuery';
import { getTRSCluster } from 'API/TRSCluster/getTRSCluster';

const useGetTRSCluster = (clusterId, enabled = true) => {
    return useQuery({
        queryKey: ['TRSCluster', clusterId],
        queryFn: async () => {
            try {
                const response = await getTRSCluster(clusterId);
                return response.data;
            } catch (error) {
                console.error('Error fetching TRS cluster:', error);
                throw error;
            }
        },
        enabled: enabled && !!clusterId,
        staleTime: 5 * 60 * 1000, // 5 minutes
        retry: 2,
        refetchOnWindowFocus: false,
    });
};

export default useGetTRSCluster;
